import { render, staticRenderFns } from "./oneHotel.vue?vue&type=template&id=fb121fba"
import script from "./oneHotel.vue?vue&type=script&lang=js"
export * from "./oneHotel.vue?vue&type=script&lang=js"
import style0 from "./oneHotel.vue?vue&type=style&index=0&id=fb121fba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports